import React from "react";
// import CTABanner from "../components/Home/CTABanner";
import { FaRocket, FaUsers, FaLightbulb, FaCheckCircle, FaShieldAlt, FaMobileAlt, FaClock } from "react-icons/fa";
import { GiReceiveMoney, GiArchiveResearch } from "react-icons/gi";
import { motion } from "framer-motion";

const cardVariants = {
    hiddenLeft: { opacity: 0, x: -100 },
    hiddenRight: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
  };
const About = () => {
  return (
    <div className="bg-[#050A18] text-[#1D3557]">
      <header className="relative text-center text-white mb-10 py-28 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-[url('/images/about/about-banner.jpg')] bg-center"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/60 to-black/60"></div>

        <div className="relative z-10 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-extrabold mb-4 text-[white]">
            About <span className="text-[#4FA0FF]">Kubermax</span>
          </h1>
          <p className="text-xl opacity-90 leading-relaxed max-w-2xl mx-auto">
            Revolutionizing financial solutions for salaried individuals with speed, transparency, and trust
          </p>
        </div>
      </header>

      {/* Main Content */}
      <div className="max-w-6xl mx-auto px-5">

        {/* Our Journey & Team Section */}
        <section className="relative py-10 border-gray-700">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-40 h-40"></div>

          <div className="relative bg-[#111827]/70 rounded-2xl p-8 pt-2 md:p-10 shadow-lg  z-10">
            <div className="text-center mb-5">
               <h4 className="text-xl md:text-6xl font-extrabold mb-4 text-center relative inline-block text-[white]">
            Connect with <span className=" absolute -bottom-2 left-0 w-full h-2 text-[#4FA0FF]">Kubermax</span>
          </h4>

              <p className="text-gray-500 text-center text-lg  pt-10 mt-10 leading-relaxed max-w-3xl mx-auto mb-10">
                At Kubermax, we're driven by the mission to empower salaried
                individuals with financial freedom. Our dedicated team and streamlined
                process ensure you're supported every step of the way.
              </p>
            </div>

            <div className="flex justify-center gap-8 flex-wrap mt-12">
              {[
                {
                  icon: <FaRocket className="text-2xl text-white" />,
                  title: "Founded in 2020",
                  content: "Started with a vision to simplify salary-based financial support for working professionals"
                },
                {
                  icon: <FaUsers className="text-2xl text-white" />,
                  title: "50+ Team Members",
                  content: "Dedicated professionals working to make your financial journey seamless"
                },
                {
                  icon: <FaLightbulb className="text-2xl text-white" />,
                  title: "1M+ Customers",
                  content: "Trusted by over a million salaried individuals across India"
                }
              ].map((item, index) => (
                <div
                  key={index}
                  className="flex-1 min-w-[300px] bg-white/10 rounded-xl p-8 shadow-sm  transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
                >
                  <div className="w-14 h-14 bg-[#4FA0FF] rounded-xl flex items-center justify-center text-white mb-5">
                    {item.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-[#40A0FF] mb-4">
                    {item.title}
                  </h3>
                  <p className="text-gray-300 leading-relaxed">
                    {item.content}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

       {/* === Cards Section === */}
        {[
          {
            title: "Instant Support Approval",
            description:
              "Apply and get approved for financial support within minutes. Our automated system ensures that you receive instant decisions based on your profile.",
            image: "/images/about/about-1.jpg",
            icon: <GiReceiveMoney className="text-[#4FA0FF] text-3xl" />,
            reverse: false,
            points: [
              {
                text: "Approval in as little as 5 minutes",
                icon: <FaClock className="text-[#4FA0FF] mr-3" />,
              },
              {
                text: "24/7 application processing",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
              {
                text: "Real-time status updates",
                icon: <FaMobileAlt className="text-[#4FA0FF] mr-3" />,
              },
            ],
          },
          {
            title: "100% Digital Process",
            description:
              "Experience a paperless journey from start to finish. Upload your documents, verify your details, and get support—all online.",
            image: "/images/about/about-2.jpg",
            icon: <GiArchiveResearch className="text-[#4FA0FF] text-3xl" />,
            reverse: true,
            points: [
              {
                text: "No physical paperwork required",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
              {
                text: "eKYC and digital signatures",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
              {
                text: "Instant document verification",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
            ],
          },
          {
            title: "Secure & Trusted",
            description:
              "Your data is safe with us. We use industry-grade encryption and privacy standards to keep your information secure at all times.",
            image: "/images/about/about-3.jpg",
            icon: <FaShieldAlt className="text-[#4FA0FF] text-3xl" />,
            reverse: false,
            points: [
              {
                text: "Bank-level security protocols",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
              {
                text: "Regular security audits",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
              {
                text: "GDPR compliant data handling",
                icon: <FaCheckCircle className="text-[#4FA0FF] mr-3" />,
              },
            ],
          },
        ].map((feature, index) => (
          <motion.section
            key={index}
            initial={feature.reverse ? "hiddenRight" : "hiddenLeft"}
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={cardVariants}
            className={`my-16 rounded-2xl overflow-hidden flex flex-col md:flex-row ${
              feature.reverse ? "md:flex-row-reverse" : ""
            } shadow-sm border border-gray-700 bg-[#111827]/70 backdrop-blur-md`}
          >
            <div className="flex-1 min-w-[300px] p-8 md:p-12 flex flex-col justify-center">
              <div className="flex items-center mb-5">
                <div className="w-12 h-12 bg-[#1E293B] rounded-lg flex items-center justify-center shadow-md mr-4">
                  {feature.icon}
                </div>
                <h2 className="text-2xl font-bold text-white m-0">
                  {feature.title}
                </h2>
              </div>
              <p className="text-gray-300 text-lg leading-relaxed mb-8">
                {feature.description}
              </p>
              <ul className="list-none p-0 m-0">
                {feature.points.map((point, i) => (
                  <li key={i} className="flex items-center mb-3 text-gray-300">
                    {point.icon}
                    {point.text}
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex-1 min-w-[300px] min-h-[400px] relative flex items-center justify-center p-0 overflow-hidden">
              <div
                className={`absolute inset-0 ${
                  feature.reverse ? "bg-gradient-to-r" : "bg-gradient-to-l"
                } from-[#4FA0FF]/10 to-transparent`}
              ></div>
              <img
                src={feature.image}
                alt={feature.title}
                className="relative z-10 w-full h-full max-h-[400px] object-cover shadow-lg transition-transform duration-300 group-hover:scale-105"
              />
            </div>
          </motion.section>
        ))}

        {/* Vision & Mission Section */}
        <section className="relative py-10 overflow-hidden">
          {/* Decorative background elements */}
          <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-[radial-gradient(circle,rgba(29,53,87,0.05)_0%,transparent_70%)]"></div>
          <div className="absolute -bottom-40 -right-40 w-96 h-96 rounded-full bg-[radial-gradient(circle,rgba(255,215,0,0.05)_0%,transparent_70%)]"></div>

          <div className="max-w-7xl mx-auto px-3 md:px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-[white] mb-4 relative inline-block">
                <span className="absolute -bottom-2 left-0 w-full h-2 bg-[#40A0FF] opacity-60"></span>
                Our Core Beliefs
              </h2>
              <p className="text-lg text-gray-500 max-w-2xl mx-auto">
                The foundation of everything we do at Kubermax
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 relative z-10">
              {[
                {
                  title: "Our Mission",
                  icon: (
                    <div className="relative">
                      <div className="absolute -inset-4 bg-[#4FA0FF] rounded-full opacity-10"></div>
                      <FaRocket className="text-5xl text-[#4FA0FF] transform transition-all duration-500 group-hover:rotate-12" />
                    </div>
                  ),
                  content: "Our mission is to simplify and speed up personal financing for salaried professionals by providing quick, secure, and transparent financial support services that empower individuals to meet their financial needs without the traditional banking hassles.",
                  highlight: "Empowering salaried professionals with instant financial solutions",
                  gradient: "from-[#4FA0FF] to-[#1D3557]",
                  bgPattern: "pattern-dots-sm text-[#4FA0FF]/5"
                },
                {
                  title: "Our Vision",
                  icon: (
                    <div className="relative">
                      <div className="absolute -inset-4 bg-[#4FA0FF] rounded-full opacity-10"></div>
                      <FaLightbulb className="text-5xl text-[#4FA0FF] transform transition-all duration-500 group-hover:scale-110" />
                    </div>
                  ),
                  content: "To become India's most trusted financial support platform for the salaried workforce, offering unmatched convenience, reliability, and financial freedom through innovative digital solutions.",
                  highlight: "Leading the future of digital financial support in India",
                  gradient: "from-[#1D3557] to-[#4FA0FF]",
                  bgPattern: "pattern-waves-sm text-[#4FA0FF]/5"
                }
              ].map((card, index) => (
                <div
                  key={index}
                  className={`group relative bg-[#111827]/70 rounded-3xl p-5 md:p-10 shadow-xl border border-[#E5E5E5] overflow-hidden transition-all duration-500 hover:shadow-2xl hover:-translate-y-2 ${card.bgPattern}`}
                >
                  {/* Gradient top border */}
                  <div className={`absolute top-0 left-0 w-full h-2 bg-gradient-to-r ${card.gradient}`}></div>

                  {/* Floating icon with halo effect */}
                  <div className="mt-4 mb-8 flex justify-center">
                    {card.icon}
                  </div>

                  <h3 className="text-3xl font-bold text-[#4FA0FF] mb-6 text-center">
                    {card.title}
                  </h3>

                  <p className="text-gray-400 text-lg leading-relaxed mb-8 text-center">
                    {card.content}
                  </p>

                  <div className="mt-8 p-6 bg-gradient-to-r from-[#4FA0FF]/5 to-[#1D3557]/5 rounded-xl border-l-4 border-[#4FA0FF] transition-all duration-500 group-hover:bg-gradient-to-r group-hover:from-[#4FA0FF]/10 group-hover:to-[#1D3557]/10">
                    <p className="text-[white]/70 font-bold m-0 italic text-lg text-center">
                      "{card.highlight}"
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
 <section className="relative py-20 px-6 sm:px-10 min-h-[700px] bg-[#050A18]">
  {/* Background Image */}
  <div
    className="absolute inset-0 bg-cover bg-center -z-20"
    style={{ backgroundImage: "url('/images/step1.jpg')" }}
  />
  
  {/* Dark Overlay + Glow */}
  <div className="absolute inset-0 -z-10">
    <div className="absolute w-[500px] h-[500px] bg-[#4FA0FF]/20 blur-[130px] rounded-full top-[-100px] left-[-120px]" />
    <div className="absolute w-[450px] h-[450px] bg-[#1d8df5]/25 blur-[150px] rounded-full bottom-[-120px] right-[-120px]" />
    <div className="absolute inset-0 bg-black/50" /> {/* dark overlay */}
  </div>

  {/* Main Container */}
  <div className="max-w-6xl mx-auto relative z-10 ">
    {/* Heading */}
    <div className="text-center mb-12">
      <h2 className="text-4xl sm:text-5xl font-extrabold leading-tight text-white mb-4">
        Fast, Secure & Easy Financial Support
        <br />
        <span className="text-[#4FA0FF]">Designed For Your Needs</span>
      </h2>
      <p className="text-black/70 text-lg max-w-2xl mx-auto">
        Apply anytime and get instant approval with our seamless, digital
        financial support experience.
      </p>
    </div>

    {/* Flex Layout for Left & Right Cards */}
    <div className="flex flex-col md:flex-row gap-10">
      {/* Left Card - Steps Vertical */}
      <div className="flex-1 bg-[white]/10 backdrop-blur-xl border border-white/20 shadow-lg rounded-2xl p-8 flex flex-col">
        <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
          <span className="w-2 h-8 bg-[#4FA0FF] rounded-full mr-3"></span>
          {"How It Works"}
        </h3>
        <ul className="space-y-6">
          {[
            "Fill the quick online form quickly and easily with minimal effort",
            "Upload your documents securely in just a few steps",
            "Receive instant approval & get support directly into your account",
          ].map((step, i) => (
            <li key={i} className="flex items-start">
              <div className="w-10 h-10 bg-gradient-to-br from-[#4FA0FF] to-[#1d8df5] text-white/80 flex items-center justify-center rounded-full text-lg font-bold mr-4 shadow-md">
                {i + 1}
              </div>
              <p className="text-lg text-white/80">{step}</p>
            </li>
          ))}
        </ul>
      </div>

      {/* Right Card - CTA & Trust */}
      <div
        className="rounded-2xl p-7 bg-[white]/10 border relative overflow-hidden flex flex-col items-center"
        style={{
          borderColor: "rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(10px)",
        }}
      >
        {/* Decorative Gradient Circle */}
        <div
          style={{
            position: "absolute",
            bottom: "-50%",
            left: "-50%",
            width: "200px",
            height: "200px",
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(79,160,255,0.15) 0%, transparent 70%)",
          }}
        />

        {/* Heading */}
        <h3 className="text-2xl font-bold text-white mb-6 flex items-center justify-center">
          <svg
            className="w-7 h-7 mr-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            style={{ color: "#4FA0FF" }}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          Ready to Get Started?
        </h3>

        {/* Buttons */}
        <div className="space-y-4 w-full max-w-xs flex flex-col items-center">
          <a
            href="/apply-now"
            className="w-full font-bold rounded-xl shadow-lg transition-all duration-300 flex items-center justify-center min-h-[56px] px-8 bg-gradient-to-r from-[#4FA0FF] to-[#1d8df5] text-white text-center"
          >
            <span className="flex items-center justify-center text-lg">
              <svg
                className="w-5 h-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 7l5 5m0 0l-5 5m5-5H6"
                />
              </svg>
              Get Started Now
            </span>
          </a>
          <a
            href="#contact"
            className="w-full border-2 font-bold rounded-xl transition-all duration-300 flex items-center justify-center min-h-[56px] px-8 border-[#4FA0FF] bg-transparent text-[#4FA0FF] text-center"
          >
            <span className="flex items-center justify-center text-white text-lg">
              <svg
                className="w-5 h-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                />
              </svg>
              Contact Support
            </span>
          </a>
        </div>

        {/* Trust indicators */}
        <div
          className="mt-6 pt-6 border-t flex flex-col items-center gap-3 w-full"
          style={{ borderColor: "rgba(79,160,255,0.2)" }}
        >
          <div className="flex items-center text-white/90 text-sm">
            <svg
              className="w-5 h-5 mr-2"
              fill="currentColor"
              viewBox="0 0 20 20"
              style={{ color: "#4FA0FF" }}
            >
              <path
                fillRule="evenodd"
                d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              />
            </svg>
            100% Secure
          </div>
          <div className="flex items-center text-white/90 text-sm">
            <svg
              className="w-5 h-5 mr-2"
              fill="currentColor"
              viewBox="0 0 20 20"
              style={{ color: "#4FA0FF" }}
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                clipRule="evenodd"
              />
            </svg>
            Quick Process
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      
    </div>
  );
};

export default About;